export function checkbox(ctx) {
    return {
        styles: {
            // bg is transparent; bullet uses pretty + cb_bullet state colours
            main:   { border_width: 0, text_color: ctx.SCR_TEXT, text_font: 32 },
            bullet: {
                bg_color: ctx.SCR, border_color: ctx.BORDER, border_width: 2,
                states: {
                    checked:         { bg_color: ctx.btnBg,    border_color: ctx.BTN_BORDER_CHK },
                    pressed:         { bg_color: ctx.btnPr },
                    pressedChecked:  { bg_color: ctx.btnChkPr },
                    disabledChecked: { bg_color: ctx.BTN_DIS },
                },
            },
        },
    };
}
